export function NebulaBackground() {
    return (
        <div
            className="fixed inset-0 pointer-events-none"
            style={{
                background: `
          radial-gradient(circle at 0% 70%, rgba(255,0,128,0.15), transparent 40%),
          radial-gradient(circle at 90% 70%, rgba(0,128,255,0.15), transparent 50%),
          radial-gradient(circle at 20% 30%, rgba(0,128,255,0.15), transparent 50%),
          radial-gradient(circle at 50% 50%, rgba(128,0,255,0.1), transparent 60%)
        `,
                zIndex: 0,
            }}
        />
    );
}
